import script from "./registerLoginPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./registerLoginPopup.vue?vue&type=script&setup=true&lang=ts"

import "./registerLoginPopup.vue?vue&type=style&index=0&id=5b34b3e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b34b3e6"]])

export default __exports__